/**
 * Object.freeze is shallow: nested arrays and shared objects stay mutable.
 * Role charters and the agent_id owner map are human-edited constants (L0), so
 * every level is frozen. Internal to core; not exported from the index.
 */
export function deepFreeze<T>(value: T): T {
  if (value !== null && typeof value === "object" && !Object.isFrozen(value)) {
    Object.freeze(value);
    for (const child of Object.values(value as Record<string, unknown>)) deepFreeze(child);
  }
  return value;
}
